export default function(onUploadFile) {
    if(window.CKEDITOR && !window.CKEDITOR.plugins.registered['apiimage']) {
        window.CKEDITOR.plugins.add( 'apiimage', {
            icons: 'image',
            init: ( editor ) => {
                editor.addCommand( 'apiimage', {
                    exec: ( editor ) => {
                        let input = document.createElement('input'), notification;
                        input.type = 'file';
                        input.onchange = async e => {
                            const file = e.target.files[0];
                            if (!/image/i.test(file.type)) {
                                notification = editor.showNotification( 'Please check the correct format.', 'warning' );
                                setTimeout(() => {
                                    notification.hide()
                                }, 2000);
                                return false
                            }
                            if (file) {
                                editor.insertHtml( `<span class="spinner-border">&nbsp;</span>` );
                                const reader = new FileReader();
                                reader.onload = (evt) => {
                                    const blobBin = atob(evt.target.result.split(',')[1]);
                                    let array = [];
                                    for(let i = 0; i < blobBin.length; i++) {
                                        array.push(blobBin.charCodeAt(i));
                                    }
                                    const fileBin=new Blob([new Uint8Array(array)], {type: 'image/png'});
                                    
                                    onUploadFile(fileBin).then(url => {
                                        editor.editable().findOne( '.spinner-border' ).remove();
                                        editor.insertHtml( `<img alt="" src="${url}"/>` );
                                    }).catch((err) => {
                                        console.log(err)
                                    });
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                        input.click();
                    }
                });
                editor.ui.addButton( 'Apiimage', {
                    label: 'Imgage',
                    command: 'apiimage',
                    toolbar: 'insert,2'
                });
            }
        });
       
    }
}